<!--价格-->
<template>
  <div>
    <div class="discount" v-if="isShowDiscount">
      <!--  分期价格  -->
      <div class="priceModule-installment">
        <h3 class="installment-title">优惠</h3>
        <div class="discount-box">
          <!-- 联报 -->
          <div class="discount-hb" @click="openActivity('jointReport')" v-if="
            allAcvitity.productDetailUnionPromotionResp &&
            allAcvitity.productDetailUnionPromotionResp.promotionProductRespList.length > 1
          ">
            <div class="discount-hb-left">
              <TagComponent text="联报" />
              <span class="installment-content" v-if="allAcvitity.productDetailUnionPromotionResp">
                参与联报可立减{{
                  allAcvitity.productDetailUnionPromotionResp.maxUnionDiscountPrice
                }}元
              </span>
            </div>
            <img src="../../../assets/img/productDetail/icon_right.png" class="right-icon" alt />
          </div>
          <!-- 满减 -->
          <div
            class="discount-hb"
            v-for="(item, index) in fullReductionData"
            :key="`full${index}`"
            @click="openFullReduction(item)"
          >
            <div class="discount-hb-left">
              <TagComponent class="full-discount-tag" text="满减" />
              <span class="installment-content">{{ fullReductionTypeToText(item) }}</span>
            </div>
            <img src="../../../assets/img/productDetail/icon_right.png" class="right-icon" alt />
          </div>
          <!-- 优惠券 -->
          <!-- <div
          class="discount-hb"
          @click="openCouponAcvitity"
          v-if="couponDetail.couponId"
        >
          <div class="discount-hb-left">
            <div class="discountAmount">
              {{ couponDetail.discountAmount }}{{ couponDetail.discountType === 1 ? `元` : `折` }}
            </div>
            <p
              class="usableCondition"
              v-if="couponDetail.discountType === 1"
            >
              满{{ couponDetail.usableCondition }}减{{ couponDetail.discountAmount }}
            </p>
            <p
              class="usableCondition"
              v-else
            >
              满{{ couponDetail.usableCondition }}打{{ couponDetail.discountAmount }}折
            </p>
          </div>
          <div class="open">
            <span>领券</span><img
              src="../../../assets/img/productDetail/icon_right_color.png"
              class="right-icon"
              alt=""
            />
          </div>
          </div>-->
          <!-- 分期  放开注释时需要同时修改isShowDiscount-->
          <!-- <div class="discount-hb" v-if="canInstallment && by_stages_price > 0">
          <div class="discount-hb-left">
            <TagComponent text="分期付款"/>
            <span class="installment-content">分期支付 ¥ {{ by_stages_price }} 起</span>
          </div>
          </div>-->

          <!-- 增加买赠活动赠品（优惠券） -->
          <div v-if="wholeGiftlist && !giftMaterialList && !giftMemberList" class="discount-hb"
            @click="giveGiftsAllOpen">
            <div class="discount-hb-left">
              <TagComponent text="赠品" />

              <span v-for="(item, index) in wholeGiftlist.slice(0, 1)" :key="index" class="taxPreference">{{
                item.discountType === 1 ? `满` + item.usableCondition + `减` + item.discountAmount :
                  `满` + item.usableCondition + `打` + item.discountAmount +`折`}}</span>
            </div>
            <img src="../../../assets/img/productDetail/icon_right.png" class="right-icon" alt />
          </div>

          <!-- 增加赠品(买课赠实物活动) -->
          <div v-if="giftMaterialList && !giftMemberList" class="discount-hb" @click="giveGiftsAllOpen">
            <div class="discount-hb-left">
              <TagComponent text="赠品" />
              <span class="taxPreference addEllips">{{ giftMaterialList[0].materialName }}</span>
            </div>
            <img src="../../../assets/img/productDetail/icon_right.png" class="right-icon" alt />
          </div>
          <!-- 赠会员展示 复用实物框 -->
          <div v-if="giftMemberList" class="discount-hb" @click="giveGiftsAllOpen">
            <div class="discount-hb-left">
              <TagComponent text="赠品" />
              <span class="taxPreference addEllips">{{ giftMemberList[0].name }}</span>
            </div>
            <img src="../../../assets/img/productDetail/icon_right.png" class="right-icon" alt />
          </div>
        </div>
      </div>
      <!-- 联报弹窗 -->
      <component :is="coursePopType | typeToComponentName" :showActivity="showActivity"
        :defaultSelectCourse="defaultSelectCourse" :allActivity="allAcvitity"
        :activityData="allAcvitity.productDetailUnionPromotionResp" ref="popupRef" @close="close" />
      <!-- 满减详情 -->
      <FullReduction
        ref="fullReduction"
        :activityData="fullReductionActivityData"
        :allActivity="allAcvitity"
        :defaultSelectCourse="defaultSelectCourse"
      />
      <!--     <JointPreferencesDetail
      :showAcvitity="showAcvitity"
      :defaultSelectCourse="defaultSelectCourse"
      :activityData="allAcvitity.productDetailUnionPromotionResp"
      @close="close"
      />-->

      <!-- 赠品优惠券列表 -->
      <GiveCouponPop v-if="GiveCouponShow" @giveCouponClose="giveCouponClose" :wholeGiftlist="wholeGiftlist" />
      <!-- 赠品实物列表 -->
      <GiveGiftsPop v-if="GiveGiftsShow" @giveGiftsClose="giveGiftsClose" :giftMaterialList="giftMaterialList" />

      <!-- 新-赠品弹窗列表,包含会员、实物、券 -->
      <GiveGiftsAll :wholeGiftlist="wholeGiftlist" :giftMaterialList="giftMaterialList" :giftMemberList="giftMemberList"
        v-if="giveGiftsAllShow" @giveGiftsClose="giveGiftsAllClose" />
    </div>
    <div class="coupon_box" @click="openCouponAcvitity" v-if="isShowCoupon">
      <img class="coupon_time_icon" src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/coupon/coupon_new_icon.png"
        alt v-if="showTime" />
      <div class="coupon_left">
        <div class="coupon_left_box1" v-if="couponDetail.discountType == 2">
          <div class="left_num1">{{ couponDetail.discountAmount }}</div>
          <div class="left_num2">折</div>
        </div>
        <div class="coupon_left_box2" v-if="couponDetail.discountType == 1">
          <div class="left_num1">{{ couponDetail.discountAmount }}</div>
          <div class="left_num2">元</div>
        </div>
      </div>
      <div class="coupon_right">
        <p class="right_text" v-if="couponDetail.discountType === 1">满{{ couponDetail.usableCondition }}减{{
          couponDetail.discountAmount }}</p>
        <p class="right_text" v-else>满{{ couponDetail.usableCondition }}打{{ couponDetail.discountAmount }}折</p>
        <p class="right_text2" v-if="showTime">限时抢券：{{ showTime }}</p>
      </div>
    </div>
    <div class="couponBoxWarrp" v-if="isShowCoupon">
      <!-- 优惠券列表 -->
      <CouponList ref="couponList" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import wx from 'weixin-js-sdk';
// eslint-disable-next-line import/extensions
import TagComponent from '@/components/commonComponents/TagComponent';
// eslint-disable-next-line import/extensions
import FullReduction from '@/components/courseDetail/fullReduction/FullReduction'; // 满减
import GiveCouponPop from '@/components/courseDetail/giveCouponPop.vue';
import GiveGiftsPop from '@/components/courseDetail/giveGiftsPop.vue';
import { replaceHyphens, timerYhqCount } from '@/utils/tools';
import GiveGiftsAll from '@/components/courseDetail/giveGiftsAll.vue';
import JointPreferencesDetail from '../../../components/jointPreferences/jointPreferencesDetail.vue'; // 联报
import CouponList from '../../coupon/couponList.vue';
import { miniSchemeUrl } from '@/utils/common.js';


export default {
  components: {
    JointPreferencesDetail,
    CouponList,
    TagComponent,
    FullReduction,
    GiveCouponPop,
    GiveGiftsPop,
    GiveGiftsAll,
  },
  props: {
    by_stages_price: {
      // 分期价格
      type: [Number, String],
    },
    wholeGiftlist: {
      type: Array,
      default: () => { },
    },
    giftMaterialList: {
      type: Array,
      default: () => { },
    },
    giftMemberList: {
      type: Array,
      default: () => { },
    },
  },
  filters: {
    /** 根据type找到组件 */
    typeToComponentName(val) {
      let componentName;
      if (val === 'jointReport') {
        componentName = 'JointPreferencesDetail';
      }
      return componentName || '';
    },
  },
  data() {
    return {
      defaultSelectCourse: [], // 默认选中的主产品
      showActivity: false, // 是否展示联报详情
      couponDetail: {}, // 最优的优惠券
      salePrice: 0,
      coursePopType: '',
      fullReductionActivityData: {},
      // isShowDiscount: false,
      GiveCouponShow: false, // 赠券弹窗
      courseId: this.$route.query.courseId, // 课程id
      GiveGiftsShow: false, // 赠品弹窗
      timers: null,
      showTime: '', // 倒计时
      // giftMaterialList: [{ materialName: 111 }],
      giveGiftsAllShow: false, // 新赠品弹窗
    };
  },
  computed: {
    ...mapState(['courseBaseData', 'productSku', 'allAcvitity', 'buyStatus']),
    // 是否可分期
    canInstallment() {
      return this.salePrice >= 100;
    },
    // 是否展示优惠信息
    isShowDiscount() {
      const {
        status,
        isValid,
        validPeriodType,
        isSetStock,
        availableStock,
        isRepeatBuy,
        productId,
      } = this.courseBaseData;
      const {
        productDetailUnionPromotionResp,
        productDetailFullPromotionRespList,
      } = this.allAcvitity;
      // 未上架 || 已过期 || 已售罄 || 已下架 || 已购买且不可重复购买
      if (
        status <= 3 ||
        (!isValid && validPeriodType !== 1 && productId) ||
        (isSetStock === 1 && availableStock <= 0) ||
        status === 6 ||
        (this.buyStatus.length && isRepeatBuy === 0)
      ) {
        return false;
      }

      // eslint-disable-next-line no-unused-vars
      let flag = false;
      /* if (this.canInstallment && this.by_stages_price > 0) {
        // 分期 分期整改暂时隐藏
        flag = true;
      } */
      // if (this.couponDetail.couponId) {
      // 优惠卷
      // flag = true;
      // }
      if (productDetailUnionPromotionResp?.promotionProductRespList?.length > 1) {
        // 联报
        flag = true;
      } else if (productDetailFullPromotionRespList?.length > 0) {
        // 满减
        flag = true;
      } else if (this.wholeGiftlist) {
        // 是否带赠送的优惠券
        flag = true;
      } else if (this.giftMaterialList) {
        // 是否带赠送的实物
        flag = true;
      } else if (this.giftMemberList) {
        flag = true;
      }
      return flag;
    },
    fullReductionData() {
      return this.allAcvitity.productDetailFullPromotionRespList || [];
    },
    isShowCoupon() {
      const {
        status,
        isValid,
        validPeriodType,
        isSetStock,
        availableStock,
        isRepeatBuy,
        productId,
      } = this.courseBaseData;
      // 未上架 || 已过期 || 已售罄 || 已下架 || 已购买且不可重复购买
      if (
        status <= 3 ||
        (!isValid && validPeriodType !== 1 && productId) ||
        (isSetStock === 1 && availableStock <= 0) ||
        status === 6 ||
        (this.buyStatus.length && isRepeatBuy === 0)
      ) {
        return false;
      }

      // eslint-disable-next-line no-unused-vars
      let flag = false;
      if (this.couponDetail.couponId) {
        // 优惠卷
        flag = true;
      }
      return flag;
    },
  },
  watch: {
    productSku(data) {
      // 获取sku的价格
      this.salePrice = data.productSkuId ? data.price : this.courseBaseData.sellPrice;
      this.defaultSelectCourse = [
        {
          productId: this.courseBaseData.productId,
          skuId: data.productSkuId,
          ...this.courseBaseData,
        },
      ];
    },
    courseBaseData(data) {
      // 默认取产品的价格
      this.salePrice = data.sellPrice;
    },
    allAcvitity(data) {
      if (data.couponDetailVO) {
        const idx = 0;
        this.couponDetail = data.couponDetailVO.couponChooseRespList[idx];
        this.destroyInterval();
        this.countTime();
      }
    },
  },
  mounted() {
    this.salePrice = this.courseBaseData.productId && this.courseBaseData.sellPrice;
  },
  methods: {
    fullReductionTypeToText(item) {
      const type = item.fullDiscountType;
      const list = item.fullDiscountConditionList || [];
      if (!list.length) {
        return '';
      }
      if (type === 1) {
        return list
          .map((condition) => `满${condition.fullAmount}减${condition.discountAmount}`)
          .join('，');
      }
      const first = list[0];
      if (type === 2) {
        return `每满${first.fullAmount}减${first.discountAmount}`;
      }
      if (type === 3) {
        return `满${first.fullAmount}打${first.discountRate}折`;
      }
      return '';
    },
    async openFullReduction(item) {
      if (this.$root.$data.zxMini) {
        const path = '/subPackages/detailWebView/index';
        const url = window.location.href
        const params = url.replace(/([&?])miniSource=[^&]*&?/g, '$1');
        wx.miniProgram.navigateTo({
          url: `/subPackages/goQiHang/index?path=${encodeURIComponent(path)}&params=${encodeURIComponent(params)}`,
        });
        return;
      }
      this.fullReductionActivityData = item;
      this.$nextTick(() => {
        this.$refs.fullReduction.show = true;
      });
    },
    async openActivity(val) {
      if (this.$root.$data.zxMini) {
        const path = '/subPackages/detailWebView/index';
        const url = window.location.href
        const params = url.replace(/([&?])miniSource=[^&]*&?/g, '$1');
        wx.miniProgram.navigateTo({
          url: `/subPackages/goQiHang/index?path=${encodeURIComponent(path)}&params=${encodeURIComponent(params)}`,
        });
        return;
      }
      this.coursePopType = val;
      this.$nextTick(() => {
        this.$refs.popupRef.show = true;
      });
    },
    close() {
      this.$refs.popupRef.show = false;
    },
    async openCouponAcvitity() {
      if (this.$root.$data.zxMini) {
        const path = '/subPackages/detailWebView/index';
        const url = window.location.href
        const params = url.replace(/([&?])miniSource=[^&]*&?/g, '$1');
        wx.miniProgram.navigateTo({
          url: `/subPackages/goQiHang/index?path=${encodeURIComponent(path)}&params=${encodeURIComponent(params)}`,
        });
        return;
      }
      const { couponChooseRespList } = this.allAcvitity.couponDetailVO;
      // 当只有一个优惠券时，直接领取
      if (couponChooseRespList.length === 1) {
        if (couponChooseRespList[0].hasGetAlready === 0) {
          const couponItem = couponChooseRespList[0];
          this.$refs.couponList.receiveCoupon(couponItem, 0);
        } else {
          this.$toast('已领取');
        }
      } else {
        this.$refs.couponList.show = true;
      }
    },
    giveCouponList() {
      if (this.$root.$data.zxMini) {
        const path = '/subPackages/detailWebView/index';
        const url = window.location.href
        const params = url.replace(/([&?])miniSource=[^&]*&?/g, '$1');
        wx.miniProgram.navigateTo({
          url: `/subPackages/goQiHang/index?path=${encodeURIComponent(path)}&params=${encodeURIComponent(params)}`,
        });
        return;
      }
      this.GiveCouponShow = true;
    },
    giveCouponClose() {
      this.GiveCouponShow = false;
    },
    giveGiftsList() {
      if (this.$root.$data.zxMini) {
        const path = '/subPackages/detailWebView/index';
        const url = window.location.href
        const params = url.replace(/([&?])miniSource=[^&]*&?/g, '$1');
        wx.miniProgram.navigateTo({
          url: `/subPackages/goQiHang/index?path=${encodeURIComponent(path)}&params=${encodeURIComponent(params)}`,
        });
        return;
      }
      this.GiveGiftsShow = true;
    },
    giveGiftsClose() {
      this.GiveGiftsShow = false;
    },

    giveGiftsAllOpen() {
      if (this.$root.$data.zxMini) {
        const path = '/subPackages/detailWebView/index';
        const url = window.location.href
        const params = url.replace(/([&?])miniSource=[^&]*&?/g, '$1');
        wx.miniProgram.navigateTo({
          url: `/subPackages/goQiHang/index?path=${encodeURIComponent(path)}&params=${encodeURIComponent(params)}`,
        });
        return;
      }
      this.giveGiftsAllShow = true;
    },
    giveGiftsAllClose() {
      this.giveGiftsAllShow = false;
    },
    // 销毁定时器
    destroyInterval() {
      clearInterval(this.timers);
      this.timers = null;
      this.showTime = null;
    },
    // 倒计时
    countTime() {
      const { receiveTimeEnd } = this.couponDetail;
      // 当前时间戳
      const now = new Date().getTime();
      // 结束时间戳
      const end = new Date(replaceHyphens(receiveTimeEnd)).getTime();
      // 做判断当倒计时结束时都为0
      if (now >= end) {
        this.showTime = null;
        return;
      }
      // 用结束时间减去当前时间获得倒计时时间戳
      let temp = end - now + 1000;
      this.timers = setInterval(() => {
        temp -= 1000;
        if (temp > 0) {
          this.showTime = timerYhqCount(temp);
        } else {
          this.showTime = null;
          this.destroyInterval();
        }
      }, 1000);
    },
  },
  destroyed() {
    this.destroyInterval();
  },
};
</script>

<style lang="scss" scoped>
.priceModule-installment {
  /* 分期 */
  display: flex;
  align-items: stretch;
  width: 100%;
  padding: 0 36px 28px 36px;
  background: #fff;

  .installment-title {
    margin-top: 10px;
    margin-right: 19px;
    // padding-top: 16px;
    color: #333;
    font-weight: 600;
    font-size: 25px;
    line-height: 43px;
  }

  .discount-box {
    display: flex;
    flex: 1;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;

    // 分期
    .discount-hb {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      margin-top: 10px;
      margin-bottom: 20px;
      padding-bottom: 2px;
      padding-left: 10px;

      &:last-child {
        margin-bottom: 0;
      }

      .discount-hb-left {
        display: flex;
        flex: 1;
        align-items: stretch;
        justify-content: flex-start;
        min-width: 0;
      }

      ::v-deep .full-discount-tag.tag-component {
        flex-shrink: 0;
        align-self: flex-start;
        box-sizing: border-box;
        width: auto;
        min-width: 0;
        height: 40px;
        padding: 2px 8px 0;
        color: rgba(255, 108, 2, 1);
        font-weight: normal;
        font-size: 24px;
        font-family: PingFangSC-Regular, 'PingFang SC', sans-serif;
        line-height: 34px;
        white-space: nowrap;
        text-align: justify;
        background-color: rgba(255, 126, 32, 0.15);
        border: 2px solid rgba(255, 108, 2, 1);
        border-radius: 4px;
      }

      .right-icon {
        width: 43px;
      }

      .open {
        display: flex;
        align-items: center;
        justify-content: flex-end;

        span {
          // padding-top: 8px;
          color: #fa8947;
          font-size: 25px;
          white-space: nowrap;
        }
      }

      .installment-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 43px;
        margin: 0 26px 0 0;
        padding: 0 10px;
        color: #ff6c02;
        font-size: 22px;
        background: rgba(255, 126, 32, 0.15);
        border: 1.1px solid #ff6c02;
        border-radius: 4px;
      }

      // .discountAmount {
      //   box-sizing: border-box;
      //   height: 36px;
      //   margin: 0 26px 0 0;
      //   padding: 0 20px;
      //   color: #ff6c02;
      //   font-size: 22px;
      //   line-height: 36px;
      //   white-space: nowrap;
      //   text-align: center;
      //   background: url('../../../assets/img/productDetail/icon_coupon.png') no-repeat center;
      //   background-size: 100% 36px;
      // }
      // .usableCondition {
      //   color: #333;
      //   font-size: 25px;
      //   line-height: 36px;
      //   word-wrap: break-word;
      //   word-break: break-all;
      // }
      .installment-content {
        margin-left: 22px;
        color: #333;
        font-size: 25px;
        line-height: 36px;
        word-break: break-all;
      }
    }
  }
}

.taxPreference {
  margin-left: 22px;
  color: #333;
  font-weight: 400;
  font-size: 25px;
  line-height: 36px;
}

.addEllips {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

::v-deep .van-icon-arrow {
  color: #787878;
  font-size: 19px;
}

.coupon_box {
  position: relative;
  display: flex;
  height: 156px;
  margin-bottom: 36px;
  margin-left: 36px;

  .coupon_time_icon {
    position: absolute;
    top: 0;
    left: 0;
    width: 105px;
    height: 43px;
  }

  .coupon_left {
    width: 185px;
    height: 156px;
    background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/coupon/coupon_new_left.png') no-repeat;
    background-size: cover;

    .coupon_left_box1 {
      display: flex;
      justify-content: center;
      width: 171px;
      height: 156px;

      .left_num1 {
        height: 80px;
        margin-top: 45px;
        color: #fff;
        font-weight: normal;
        font-size: 72px;
        font-family: Arial, sans-serif;
        line-height: 80px;
      }

      .left_num2 {
        height: 36px;
        margin-top: 76px;
        color: #fff;
        font-weight: 600;
        font-size: 25px;
        font-family: 'PingFang SC', sans-serif;
        line-height: 36px;
      }
    }

    .coupon_left_box2 {
      display: flex;
      justify-content: center;
      width: 171px;
      height: 156px;

      .left_num1 {
        height: 56px;
        margin-top: 60px;
        color: #fff;
        font-weight: normal;
        font-size: 51px;
        font-family: Arial, sans-serif;
        line-height: 56px;
      }

      .left_num2 {
        height: 36px;
        margin-top: 73px;
        color: #fff;
        font-weight: 600;
        font-size: 25px;
        font-family: 'PingFang SC', sans-serif;
        line-height: 36px;
      }
    }
  }

  .coupon_right {
    display: flex;
    flex-direction: column;
    gap: 11px;
    justify-content: center;
    width: 493px;
    height: 156px;
    background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/coupon/coupon_new_right.png') no-repeat;
    background-size: cover;

    .right_text {
      display: block;
      height: 33px;
      color: #fff;
      font-weight: 500;
      font-size: 29px;
      font-family: 'PingFang SC', sans-serif;
      line-height: 33px;
    }

    .right_text2 {
      height: 29px;
      color: #fff;
      font-weight: 400;
      font-size: 22px;
      font-family: 'PingFang SC', sans-serif;
      line-height: 29px;
    }
  }
}

.couponBoxWarrp {
  padding-bottom: 36px;

  .couponBoxCenter {
    display: flex;
    align-items: center;
    width: 678px;
    height: 91px;
    margin: 0 auto;
    background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/courseDetail/couponNewBg.png') no-repeat center;
    background-size: 100% 100%;

    .couponDisType {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      width: 82%;

      .discountAmount {
        width: 111px;
        color: #fff;
        font-weight: 600;
        font-size: 29px;
        line-height: 49px;
        text-align: center;
        border-radius: 11px 181px 181px 11px;
      }

      .usableCondition {
        margin-bottom: 12px;
        padding-left: 18px;
        color: #fff;
        font-weight: 400;
        font-size: 25px;
      }

      .timeCount {
        padding-left: 18px;
        color: #fff;
        font-weight: 400;
        font-size: 25px;
      }
    }

    .openCouList {
      width: 18%;
      height: 40px;
      margin-right: 22px;
      color: #fff;
      font-weight: 500;
      font-size: 18px;
      line-height: 40px;
      text-align: center;
      background: #fd6a81;
      border-radius: 20px;
    }
  }
}
</style>
